@let flow = layout();
@let selected = selectedPositionId();

<div class="flow-header">
  <div class="column-header">ZLECENIA</div>
  <div></div>
  <div class="column-header">POZYCJE</div>
  <div></div>
  <div class="column-header">WYSYŁKI</div>
</div>

<div class="flow-body">
  <div class="column">
    @for (order of flow.orders; track order.orderId) {
      <a class="node" [class.connected]="connectedOrderIds().has(order.orderId)" [class.dimmed]="selected && !connectedOrderIds().has(order.orderId)"
        [routerLink]="['/orders', order.orderId]" title="Otwiera zlecenie">
        <div class="node-title text-mono">{{ order.orderNumber }}</div>
        <div class="node-line">{{ order.statusLabel }}</div>
        <div class="node-line text-mono">{{ order.windowLabel ?? '—' }}</div>
        @if (order.alsoCoversLabel) {
          <div class="node-line muted">obejmuje też {{ order.alsoCoversLabel }}</div>
        }
      </a>
    } @empty {
      <div class="column-empty">brak zleceń</div>
    }
  </div>

  <svg class="edges" [attr.width]="gapWidth" [attr.height]="flow.height" [attr.viewBox]="'0 0 ' + gapWidth + ' ' + flow.height">
    @for (edge of flow.productionEdges; track edge.key) {
      <path class="edge" [class.highlighted]="edge.positionId === selected" [class.dimmed]="selected && edge.positionId !== selected" [attr.d]="edge.path"></path>
    }
    @for (edge of flow.productionEdges; track edge.key) {
      <text class="edge-label" [class.dimmed]="selected && edge.positionId !== selected" [attr.x]="edge.labelX" [attr.y]="edge.labelY">{{ formatAmount(edge.amount, edge.unit) }}</text>
    }
  </svg>

  <div class="column">
    @for (position of flow.positions; track position.id) {
      <div class="node position" [class.open]="position.open" [class.closed]="position.closed" [class.selected]="position.id === selected"
        (click)="togglePosition(position.id)" title="Podświetla powiązania pozycji">
        <div class="node-title">{{ position.name }}@if (position.closed) {<span class="closed-mark" title="Wysłano w całości"> ✓</span>}</div>
        <div class="node-line">zamówiono <span class="text-mono">{{ formatAmount(position.amount, position.unit) }}</span></div>
        <div class="node-line" [class.uncovered]="position.open">w zleceniach <span class="text-mono">{{ formatAmount(position.allocatedAmount, position.unit) }}</span></div>
        <div class="node-line">wysłano <span class="text-mono">{{ formatAmount(position.shippedAmount, position.unit) }}</span></div>
      </div>
    } @empty {
      <div class="column-empty">brak pozycji</div>
    }
  </div>

  <svg class="edges" [attr.width]="gapWidth" [attr.height]="flow.height" [attr.viewBox]="'0 0 ' + gapWidth + ' ' + flow.height">
    @for (edge of flow.shippingEdges; track edge.key) {
      <path class="edge" [class.planned]="edge.planned" [class.highlighted]="edge.positionId === selected" [class.dimmed]="selected && edge.positionId !== selected" [attr.d]="edge.path"></path>
    }
    @for (edge of flow.shippingEdges; track edge.key) {
      <text class="edge-label" [class.dimmed]="selected && edge.positionId !== selected" [attr.x]="edge.labelX" [attr.y]="edge.labelY">{{ formatAmount(edge.amount, edge.unit) }}</text>
    }
  </svg>

  <div class="column">
    @for (shipment of flow.shipments; track shipment.shipmentId) {
      <a class="node" [class.connected]="connectedShipmentIds().has(shipment.shipmentId)" [class.dimmed]="selected && !connectedShipmentIds().has(shipment.shipmentId)"
        [routerLink]="['/shipments', shipment.shipmentId]" title="Otwiera wysyłkę">
        <div class="node-title text-mono">{{ shipment.shipmentNumber }}</div>
        <div class="node-line">{{ shipment.transport }}</div>
        <div class="node-line" [class.muted]="shipment.planned">{{ shipment.statusLabel }}</div>
      </a>
    } @empty {
      <div class="column-empty">brak wysyłek</div>
    }
  </div>
</div>
